import { cn } from '@/utils/shad';
import { MouseEventHandler } from 'react';

export const List = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
  return <ul className={cn('flex min-w-45 list-none flex-col', className)}>{children}</ul>;
};

export const ListItem = ({
  children,
  className,
  onClick,
  onMouseDown,
  'data-tour': dataTour,
  'data-testid': dataTestId,
}: React.PropsWithChildren<{
  className?: string;
  onClick?: MouseEventHandler;
  onMouseDown?: MouseEventHandler;
  'data-tour'?: string;
  'data-testid'?: string;
}>) => {
  return (
    <li
      className={cn(
        'list-none py-2 pl-3 font-semibold transition-colors hover:cursor-pointer hover:bg-accent hover:text-accent-foreground',
        className,
      )}
      onClick={onClick}
      onMouseDown={onMouseDown}
      tabIndex={0}
      role="button"
      data-tour={dataTour}
      data-testid={dataTestId}
    >
      {children}
    </li>
  );
};
ListItem.displayName = 'ListItem';

export const ListItemNoHover = ({
  children,
  className,
  onClick,
}: React.PropsWithChildren<{ className?: string; onClick?: MouseEventHandler }>) => {
  return (
    <li className={cn('flex w-full pl-3', className)} onClick={onClick} tabIndex={0} role="button">
      {children}
    </li>
  );
};
ListItemNoHover.displayName = 'ListItemNoHover';
